
/*
form is where we have all the details for all the inputs
for the entity  forms
each entity has their own form
*/
export const form   =  [
 
	{	
		name: "name", 
		value:'', 		
		id:'provider_quickform_name',
		html:'',
		type:'textfield',
		required: true,  
	},
	{	
		name: "phone", 
		value:'', 		
		id:'provider_quickform_phone',
		html:'',
		type:'textfieldValidator',
		required: true, 
	},
	{	
		name: "email", 
		value:'', 		
		id:'provider_quickform_email',
		html:'',
		type:'textfieldValidator',
		required: true, 
	},



]



//we use this for check changes on form	
export const formCopy = JSON.parse(JSON.stringify(form)) 

